export enum PageTab {
  Templates = 'templates',
  Conflicts = 'conflicts',
  Policies = 'policies'
}
